<template>
    <div>
        <div class="container container-mob">

            <p style="color: black; text-align: left; font-size: 2em; font-weight:bold">
                <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>{{$t('message.realized_objects')}}</p>
        </div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">{{$t('message.main_page')}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t('message.realized_objects')}}</li>
                </ol>
            </nav>
            <hr>
            <div v-if="realized.length === 0" class="text-center">
                <img src="/static/images/nodatafound.png" width="100%"/>
                       <h2 class="">{{$t('message.notfound')}}</h2>

            </div>
            <b-card-group columns>
                <b-card v-for="item in realized" :key="item.id" :img-src="(item.photo) ? '/static/uploads/'+item.photo: '/static/images/no_image.jpg'" img-alt="Image"  img-height="168" img-top>
                    <b-card-title style="min-height: 60px">{{  func_substring(item['name_'+selectedLocale.suffix.toLowerCase()], 30 ) }}</b-card-title>
                    <hr/>
                    <b-card-text style="min-height: 100px" v-html="func_substring(item['body_'+selectedLocale.suffix.toLowerCase()], 100 )"></b-card-text>
                    <hr/>
                    <span style="text-align:right;">22.12.2021</span>
                    <b-row>
                        <b-col lg="12" class="pb-2 text-center">
                            <router-link :to="'/realized-objects/'+item.r_id">
                                <b-button variant="primary" >{{$t('message.read')}}</b-button>
                            </router-link>
                        </b-col>
                    </b-row>
                </b-card>
            </b-card-group>
            <div class=" py-3">
                <!--<b-pagination
                        total-rows="3"
                        per-page="1"
                        aria-controls="my-table"
                        align="center"
                ></b-pagination>-->
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getRealized} from '../api/index'
    export default {
        name: 'realized-objects',
        data() {
          return {
              realized: []
          }
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                getRealized().then(res => {
                    this.realized = res.data
                })
            },
            func_substring(val, count) {
                return  (val.length > count) ? val.substring(0,count)+'...' : val
            }
        }
    }
    // getRealizedSchools
</script>

<style>
    .container-mob {
        padding-top: 100px;
        display: flex;
    }
</style>
